import React from 'react';
import styles from './Footer.module.css';
import { Typography } from '@material-ui/core';
import GithubIcon from '@material-ui/icons/GitHub';
import TwitterIcon from '@material-ui/icons/Twitter';


const Footer = () => {
 return(
  <div className={styles.container}>
    <Typography color="textSecondary">Created by <a href="https://wahabgiwa.dev">Wahab Giwa</a></Typography>
    <a href="https://github.com/auleki" rel="noopener noreferrer" target="_blank"><GithubIcon /></a>
    <a href="https://twitter.com/augh0st" rel="noopener noreferrer" target="_blank"><TwitterIcon /></a>
  </div>
  
); 
};


export default Footer;